import http from '@/utils/services/http'

export function retiradaEmMassa (data) {
  return http.post('/api/automacoes/retirada-em-massa', JSON.stringify(data))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function lotesLeilaoEmMassa (data) {
  return http.post('/api/automacoes/lotes-leilao-em-massa', JSON.stringify(data))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function scanEmMassa (formData) {
  return http.post('/api/automacoes/scan-em-massa', formData, {
    headers: {'Content-Type': 'multipart/form-data'}
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}



// WEBPACK FOOTER //
// ./src/domain/automacoes/services/index.js